import { useState } from "react";
import { Menu } from "react-admin";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { AboutDialog } from "./about-dialog.component";

export const CustomMenu = () => {
  const [aboutOpen, setAboutOpen] = useState(false);

  return (
    <>
      <Menu>
        <Menu.ResourceItems />
        <ListItemButton
          onClick={() => setAboutOpen(true)}
          sx={{ pl: 2, color: "text.secondary" }}
        >
          <ListItemIcon sx={{ minWidth: 40, color: "inherit" }}>
            <InfoOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Sobre" />
        </ListItemButton>
      </Menu>
      <AboutDialog open={aboutOpen} onClose={() => setAboutOpen(false)} />
    </>
  );
};
